/**
 * Is this listing sold?
 *
 * A sold Dhobara listing is not closed — it stays published with zero stock.
 * Until now the browse pages filtered those out with `minStock: 1`, so a sold
 * piece simply vanished. Showing it marked SOLD is better for a resale
 * marketplace: it proves things actually sell, keeps a designer's page from
 * emptying out, and gives a returning visitor's bookmark somewhere to land.
 *
 * The listing must have been fetched with `include: ['currentStock']` for
 * this to know anything. Without it, currentStock is undefined and we treat
 * the listing as available rather than guessing — better to show a Buy button
 * that fails late than to mark a live piece sold.
 */

export const isSoldOut = listing => {
  const quantity = listing?.currentStock?.attributes?.quantity;
  return typeof quantity === 'number' && quantity === 0;
};
